import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  Button,
  Col,
  FlexboxGrid,
  Icon,
  List,
  Loader,
  Message,
  MultiCascader,
  Panel,
  Placeholder,
  Row,
  Uploader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import {
  getContractChangeFile,
  getEContractFile,
  saveContractChangeForm,
  sendContractChangeSign,
  updateSendEditContract,
  updateSendEditContractSecureApprove,
} from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'

import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, PROCESS_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import { downloadFileByPath } from '../../redux/actions/accountingAssetClosure'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import ConfirmWidget from '../confirm/ConfirmWidget'
import AppContext from '../../context/AppContext'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import scrollToComponent from 'react-scroll-to-component'
import InputForm from '../../components/forms/input/InputForm'
import CenterChangeFormForm from '../contractChangeForm/CenterChangeFormForm'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import InputDateForm from '../../components/forms/input/InputDateForm'
import moment from 'moment'
import InputCheckboxSingleForm from '../../components/forms/input/InputCheckboxSingleForm'
import UploaderForm from '../../components/forms/input/UploaderForm'
import ContractChangeExtendPeriodAttach from './ContractChangeExtendPeriodAttach'
import {
  isRequired,
  isRequiredFiled,
  isValidators,
  isValidFileType,
  requiredFiled,
} from '../../utils/ValidatorUtils'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { cloneDeep, find, forEach, includes, isEmpty } from 'lodash-es'
import { getProjectBudget } from '../../redux/actions/budget'
import ActivityWidgets from '../projectProposal/budget/ActivityWidgets'
import { handleOnChangeIsEdit } from '../../utils/widget'
import ActivityBudget from '../../pages/proposal/projectProposalView/ActivityBudget'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import HTMLWidget from '../HTMLWidget'
import EditButton from '../../components/buttons/editButton/EditButton'
import {
  contractExtendPeriodCancel,
  contractExtendPeriodNotApprove,
  contractExtendPeriodRequestApprove,
  contractExtendPeriodSave,
} from '../../redux/actions/contractExtendPeriod'
import { DD_MM_YYYY, DD_MM_YYYY_SLASH, REQUEST_DATE_FORMAT } from '../../constants/date'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'
import InputCheckboxForm from '../../components/forms/input/InputCheckboxForm'
import ContractChangeExtendPeriodBudget from './ContractChangeExtendPeriodBudget'
import WithdrawRequestStatusWidget from '../progressReportWidget/withdraw/WithdrawRequestStatusWidget'
import { getWithdrawRequestStatus } from '../../redux/actions/withdrawRequest'
import PeriodBudgetTable from './PeriodBudgetTable'
import InputMultiCascaderForm from '../../components/forms/input/InputMultiCascaderForm'
import CustomMessages from '../../components/message/CustomMessages'
import RenderPDFWidget from '../pdfWidgets/RenderPDFWidget'
import ViewButton from '../../components/buttons/viewButton/ViewButton'

export default function ContractChangeExtendPeriodWidget({ schema, ...props }) {
  const { Paragraph, Graph } = Placeholder

  const { theme } = React.useContext(AppContext)

  const [section, setSection] = useState()
  const [isShowPopUp, setIsShowPopUp] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isPdfLoading, setPdfIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues, setError } =
    useForm()
  const [formSchema, setFormSchema] = useState(schema)
  // const [isEdit, setIsEdit] = useState(false)
  const [isRefash, setIsRefash] = useState(false)
  const [delFiles, setDelFiles] = useState([])

  const [withdrawRequestStatusSchema, setWithdrawRequestStatusSchema] = useState()

  const history = useHistory()

  const projectId = sessionStorage.getItem('projectId')

  const [actionType, setActionType] = useState()
  const [actionName, setActionName] = useState()
  const [disabledAction, setDisabledAction] = useState()

  const [activitySchema, setActivitySchema] = useState()
  const [summaryBudget, setSummaryBudget] = useState()

  const [overExtend, setOverExtend] = useState()
  const [budgetSchemaErr, setBudgetSchemaErr] = useState()

  const [note, setNote] = useState()
  const [newEndDate, setNewEndDate] = useState()
  const [attachValues, setAttachValues] = useState(new Map())
  const [attachErrMsg, setAttachErrMsg] = useState()
  const [request, setRequest] = useState()

  const [changeType, setChangeType] = useState()

  const [reasonType, setReasonType] = useState()
  const [otherReason, setOtherReason] = useState()

  const [periodBudgetChange, setPeriodBudgetChange] = useState([])

  const [requestFile, setRequestFile] = useState()
  const [requestFileErroMsg, setRequestFileErroMsg] = useState()
  const [reasonErroMsg, setReasonErroMsg] = useState()

  useEffect(() => {
    if (schema?.projectVersionId) {
      handleGetBudgetSchema(schema.projectVersionId)
      handleGetWithdrawRequestStatusSchema(schema.projectVersionId)
    }
  }, [])

  useEffect(() => {
    if (formSchema) {
      setOverExtend(formSchema.overExtend?.value)
      setChangeType(formSchema.changeType?.value || [])
      //console.log('formSchema.changeType?.value || [] : ', formSchema.changeType?.value || [])
      //console.log('formSchema?.newEndDate?.value : ', formSchema?.newEndDate)

      setNewEndDate(formSchema?.newEndDate?.value || undefined)

      // setNewEndDate(
      //   formSchema?.newEndDate?.value
      //     ? moment(formSchema.newEndDate.value, REQUEST_DATE_FORMAT).toDate()
      //     : undefined
      // )

      var changes = formSchema.periodBudget?.change || []

      //console.log('changes : ', changes)

      setPeriodBudgetChange(changes)
      setReasonType(changes.length > 0 ? changes[changes.length - 1].reasonType : [])
      setOtherReason(changes.length > 0 ? changes[changes.length - 1].otherReason : '')

      if (formSchema.isApprover) {
        let requestFile = formSchema?.attachForm?.values?.find((e) => e.typeId == '-')

        if (requestFile) {
          handleDownloadRequestFile(requestFile)
        }
      }
    }
  }, [formSchema])

  const handleGetBudgetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectBudget(projectVersionId)
      // console.log('__________schema ', _schema)

      setSummaryBudget(_schema?.forms?.summary)
      setActivitySchema(_schema)
    } catch (e) {
      console.log('error', e)

      setSummaryBudget('')
      setActivitySchema('')

      setBudgetSchemaErr('ดึงข้อมูลกิจกรรมและงบประมาณไม่สำเร็จ')
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetWithdrawRequestStatusSchema = async (projectVersionId) => {
    setIsLoading(true)
    try {
      const _withdrawRequestStatus = await getWithdrawRequestStatus(projectVersionId)
      setWithdrawRequestStatusSchema(_withdrawRequestStatus)
    } catch (e) {
      console.log('e', e)
    }
    setIsLoading(false)
  }

  const handleSave = async (request, projectVersionId) => {
    startLoading()
    setIsLoading(true)
    try {
      const jsonObject = Object.fromEntries(request.entries())
      // Convert the object to a JSON string
      const jsonString = JSON.stringify(jsonObject)
      console.log('jsonString : ', jsonString)

      let response = await contractExtendPeriodSave(request)
      //console.log('response', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setFormSchema(response)
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

        handleGetBudgetSchema(projectVersionId)
        onRefash()
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.messag || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCancel = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await contractExtendPeriodCancel(request)
      // console.log('response', response)
      if (response) {
        notification.open('success', {
          title: PROCESS_SUCCESS_MSG,
          duration: 5000,
        })
        setIsLoading(false)
        doneLoading()

        sessionStorage.setItem('projectId', response.projectVersionId)

        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.messag || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSendRequestApprove = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await contractExtendPeriodRequestApprove(request)
      // console.log('response', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        if (request.approvelType == 0) {
          setIsLoading(false)
          doneLoading()
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        } else {
          setFormSchema(response)
          scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

          handleGetBudgetSchema(request.projectVersionId)
          onRefash()
        }
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleSendRequestApprove Error : ', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.messag || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSendEditContractSecureApprove = async (request, projectVersionId) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await updateSendEditContractSecureApprove(request, projectVersionId)
      // console.log('response isDirector', response)

      if (response.success) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        if (response.secureApprovalUri) {
          doneLoading()
          setIsLoading(false)
          window.location.href = response.secureApprovalUri
        } else {
          setIsLoading(false)
          doneLoading()
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      } else {
        notification.open('error', {
          title: response.error || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.messag || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleNotApprove = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await contractExtendPeriodNotApprove(request)
      // console.log('response', response)
      if (response) {
        notification.open('success', {
          title: PROCESS_SUCCESS_MSG,
          duration: 5000,
        })

        setIsLoading(false)
        doneLoading()

        sessionStorage.setItem('projectId', response.projectVersionId)

        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleNotApprove Error : ', e)

      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownload = async (type, data) => {
    startLoading()
    setIsLoading(true)
    try {
      var file = await downloadFileByPath(data.filePath)
      if (file) {
        if ('preview' == type) {
          previewFile(file, data.fileName)
        } else {
          downloadFile(file, data.fileName)
        }
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadRequestFile = async (data) => {
    startLoading()
    setPdfIsLoading(true)
    try {
      var file = await downloadFileByPath(data.filePath)
      if (file) {
        setRequestFile(file)
        setPdfIsLoading(false)
      } else {
        setRequestFileErroMsg(DEFAULT_ERR_MSG)
      }
    } catch (e) {
      setRequestFileErroMsg(DEFAULT_ERR_MSG)
    }
    //setPdfIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    //console.log('data', data)
    setAttachErrMsg('')
    setReasonErroMsg('')

    let notSetReasonType = periodBudgetChange.filter(
      (e) => e.isChange && (e.reasonType?.length || 0) < 1
    )

    console.log('notSetReasonType : ', notSetReasonType)

    if (notSetReasonType?.length > 0) {
      setReasonErroMsg('กรุณาระบุเหตุผล')
    } else {
      const reasonTypes = [
        ...new Set(
          periodBudgetChange.flatMap((x) => x.reasonType).map((x) => String(x).split('-')[0])
        ),
      ]

      let val = schema.values?.filter(
        (e) => reasonTypes.includes(e.reasonType) || e.reasonType == '0'
      )

      var requiredFile = val?.filter(
        (e) =>
          e.isRequired &&
          (isEmpty(e.filePath) || delFiles.includes(e.id)) &&
          (attachValues?.get(e.id)?.length || 0) < 1
      )

      if (requiredFile?.length > 0) {
        setAttachErrMsg('กรุณาแนบ "เอกสารแนบประกอบ" ที่เป็น * แดงให้ครบทุกรายการ')
      } else {
        submitAction(data, false)
      }
    }
  }

  const onSaveDraf = () => {
    setAttachErrMsg('')

    var data = {
      changeType: changeType,
      newEndDate: getValues('newEndDate'),
      detail: getValues('detail'),
      overExtend: overExtend,
      //periodBudget: getValues('periodBudget'),
    }
    submitAction(data, true)
  }

  const submitAction = (data, isDraf) => {
    console.log('data :', data)

    const formData = new FormData()

    formData.append('Id', formSchema.id)
    formData.append('ProjectVersionId', formSchema.projectVersionId)

    formData.append('ChangeType', changeType)
    formData.append('OverExtend', overExtend)

    formData.append('NewEndDate', data?.newEndDate || getValues('newEndDate'))
    // formData.append('ActivityBudget', data?.activityBudget || false)
    formData.append('Detail', data?.detail || getValues('detail'))
    formData.append('IsDraf', isDraf)

    var attIndex = 0

    attachValues?.forEach((value, key) => {
      // console.log(key, value)
      if (value?.file?.length > 0) {
        formData.set(`Attachs[${attIndex}].FileID`, key)
        formData.set(`Attachs[${attIndex}].FileTypeId`, value.typeId)
        formData.set(`Attachs[${attIndex}].File`, value.file[0].blobFile)
        attIndex++
      }
    })

    var periodBudgetIndex = 0
    periodBudgetChange?.forEach((value) => {
      console.log('periodBudgetChange value ', value)
      if (value) {
        formData.set(`PeriodBudgets[${periodBudgetIndex}].Id`, value.id)
        formData.set(`PeriodBudgets[${periodBudgetIndex}].Period`, value.period)
        formData.set(`PeriodBudgets[${periodBudgetIndex}].StartDate`, value.newStartDate)
        formData.set(`PeriodBudgets[${periodBudgetIndex}].EndDate`, value.newEndDate)
        formData.set(`PeriodBudgets[${periodBudgetIndex}].ReasonType`, value.reasonType?.join(','))
        formData.set(`PeriodBudgets[${periodBudgetIndex}].OtherReason`, value.otherReason || '')
        formData.set(`PeriodBudgets[${periodBudgetIndex}].Amount`, value.newAmount)
        formData.set(`PeriodBudgets[${periodBudgetIndex}].EnableChange`, value.enableChange)
        formData.set(`PeriodBudgets[${periodBudgetIndex}].IsChange`, value.isChange)

        periodBudgetIndex++
      }
    })

    delFiles?.forEach((e) => {
      formData.append('DelAttachs', e)
    })

    //const jsonObject = Object.fromEntries(formData.entries())
    // // Convert the object to a JSON string
    // const jsonString = JSON.stringify(jsonObject)
    // console.log(jsonString)

    if (isDraf) {
      handleSave(formData, formSchema.projectVersionId)
    } else {
      setRequest(formData)
      setActionType(1)
      setIsShowPopUp(true)
    }
  }

  const onConfirm = () => {
    setDisabledAction(true)
    if (![1, 9].includes(actionType) && isRequired(formSchema.note.validators) && isEmpty(note)) {
      setError(formSchema.note.name, {
        type: 'manual',
        message: formSchema.note.validators.filter((e) => e.type == 'REQUIRED')[0].errorMessage,
      })
    } else {
      setIsShowPopUp(false)
      if (actionType == 1) {
        handleSave(request, formSchema.projectVersionId)
      } else if (actionType == 9) {
        handleCancel({
          id: formSchema.id,
          projectVersionId: formSchema.projectVersionId,
          approvelType: 3,
          note: note || '',
        })
      } else if ([2, 3].includes(actionType) && !formSchema.isApprover) {
        let req = {
          id: formSchema.id,
          projectVersionId: projectId,
          approvelType: actionType == 2 ? 0 : 1,
          note: note || '',
        }

        handleSendRequestApprove(req)
      } else if ([2, 4].includes(actionType) && formSchema.isApprover) {
        let req = {
          id: formSchema.id,
          projectVersionId: projectId,
          value: note || '',
          //contractModifyType: actionType == 2 ? [] : changeType ? ['1', '3'] : ['1'],
          isCriticalImpacted: false, //always false
          sendToGrantee: actionType == 2,
          noteSendToGrantee: note || '',
        }

        handleSendEditContractSecureApprove(req, projectId)
      } else if (5 == actionType) {
        let req = {
          id: formSchema.id,
          projectVersionId: formSchema.projectVersionId,
          //approvelType: actionType == 2 ? 0 : 1,
          note: note || '',
        }

        handleNotApprove(req)
      }
      setNote('')
    }
  }

  const onReasonTypeChange = (val) => {
    setReasonType(val)
    //console.log('val : ', val)

    if (val?.length > 0 && reasonErroMsg) {
      setReasonErroMsg('')
    }

    let datas = [...periodBudgetChange]

    let reasonTypeName = []
    for (let index = 0; index < formSchema.periodBudget.reasonType.options.length; index++) {
      const element = formSchema.periodBudget.reasonType.options[index]

      if (val?.includes(element.value)) {
        reasonTypeName.push(element.label)
      } else {
        element.children?.forEach((e) => {
          if (val?.includes(e.value)) {
            reasonTypeName.push(element.label)
          }
        })
      }
    }

    datas[datas.length - 1].isChange = true
    datas[datas.length - 1].reasonType = val || []
    datas[datas.length - 1].reasonTypeName = reasonTypeName.join(',')

    setPeriodBudgetChange(datas)
  }

  const onDeleteFile = (data) => {
    setDelFiles([...new Set([...delFiles, data.id])])
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {budgetSchemaErr ? (
          <>
            <Message
              type="error"
              showIcon
              style={{ marginBottom: 10 }}
              description={budgetSchemaErr}
            />
          </>
        ) : (
          <>
            {formSchema?.msg?.map((item) => {
              return (
                <Message
                  type={item.msgType || 'info'}
                  style={{ marginBottom: 10 }}
                  description={
                    <div>
                      {item.position} : {item.name}
                      <div style={{ marginLeft: 30, marginTop: 10 }}>
                        <HTMLWidget data={item.note} />
                      </div>
                    </div>
                  }
                />
              )
            })}

            {!isRefash && (
              <>
                <strong>
                  {changeType?.length == 1 && changeType[0] == '2'
                    ? `ขอแก้ไขกิจกรรมและงบประมาณครั้งที่ ${formSchema.activityBudgetSeq}`
                    : `ขอขยายเวลาครั้งที่ ${formSchema.periodSeq}`}{' '}
                </strong>
                <p>
                  <strong>สถานะ : </strong> {formSchema.statusName}
                </p>

                <>
                  {formSchema.periodBudget && (
                    <>
                      <Panel
                        header={formSchema.periodBudget.header}
                        bordered
                        collapsible
                        defaultExpanded={!schema.isApprover}
                        style={{ marginBottom: 10, marginTop: 10 }}
                      >
                        <PeriodBudgetTable data={formSchema.periodBudget.current} />
                      </Panel>
                    </>
                  )}

                  {formSchema.changeType && (
                    <div style={{ marginBottom: 10 }}>
                      {formSchema.disabled ? (
                        <>
                          <p>
                            <strong>{formSchema.changeType.label} : </strong>
                          </p>
                          {formSchema.changeType.options?.map((e) => {
                            return (
                              <p style={{ marginLeft: 20 }}>
                                <Icon
                                  size="lg"
                                  icon={
                                    formSchema.changeType.value?.includes(e.value)
                                      ? 'check-square-o'
                                      : 'square-o'
                                  }
                                />{' '}
                                {e.label}
                              </p>
                            )
                          })}
                        </>
                      ) : (
                        <>
                          <InputCheckboxForm
                            schema={formSchema.changeType}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            disabled={formSchema.disabled}
                            value={changeType}
                            onChange={(val) => {
                              let periodChange = [...periodBudgetChange]
                              if (val?.length < 1 || val[0] == '2') {
                                //ไม่เลือกหรือแก้งบอย่างเดียว
                                setPeriodBudgetChange(periodChange)
                              } else if (val?.length == 1 && val[0] == '1') {
                                //ขยายเวลาอย่างเดียว
                                periodChange[periodChange.length - 1].newEndDate = moment(
                                  newEndDate,
                                  REQUEST_DATE_FORMAT
                                ).format(DD_MM_YYYY_SLASH)

                                periodChange[periodChange.length - 1].isChange = true

                                setPeriodBudgetChange(periodChange)
                              } else if (!val?.includes('2') || !val?.includes('3')) {
                                setPeriodBudgetChange(periodChange)
                              }

                              setChangeType(val)
                            }}
                          />
                          <Message
                            showIcon
                            type="warning"
                            description="กรณี ขอเพิ่ม/ลด งวดการเบิกจ่ายเงินงบประมาณ จะต้องเลือกประเภทการขอเปลี่ยน 2 หัวข้อ ดังนี้ กิจกรรมและงบประมาณ และ งวดการเบิกจ่ายเงินงบประมาณ"
                          />
                        </>
                      )}
                    </div>
                  )}

                  {changeType?.length > 0 && (
                    <>
                      {changeType?.includes('1') && (
                        <Panel
                          header={'ระยะเวลาโครงการ'}
                          bordered
                          collapsible
                          defaultExpanded={!schema.isApprover}
                          style={{ marginBottom: 10, marginTop: 10 }}
                        >
                          <div style={{ marginBottom: -10 }}>
                            {formSchema.alertMessage && (
                              <Message
                                showIcon
                                type="info"
                                description={formSchema.alertMessage}
                                style={{ marginBottom: 10 }}
                              />
                            )}

                            {formSchema.overExtend && (
                              <>
                                {formSchema.disabled ? (
                                  <>
                                    {overExtend && (
                                      <Message
                                        showIcon
                                        type="warning"
                                        description={formSchema.overExtend.label}
                                        style={{ marginTop: 10, marginBottom: 10 }}
                                      />
                                    )}
                                    {/* <p style={{ marginLeft: 20 }}>
                                        <Icon
                                          size="lg"
                                          icon={overExtend ? 'check-square-o' : 'square-o'}
                                        />{' '}
                                        {formSchema.overExtend.label}
                                      </p> */}
                                  </>
                                ) : (
                                  <InputCheckboxSingleForm
                                    schema={formSchema.overExtend}
                                    register={register}
                                    Controller={Controller}
                                    control={control}
                                    errors={errors}
                                    setValue={setValue}
                                    clearErrors={clearErrors}
                                    disabled={formSchema.disabled}
                                    onChange={(val) => {
                                      setOverExtend(val)
                                      let d
                                      if (val) {
                                        d = formSchema.maxEndDate
                                          ? moment(formSchema.maxEndDate)
                                              .add(1, 'days')
                                              .format(REQUEST_DATE_FORMAT)
                                          : undefined
                                      } else {
                                        d = formSchema.newEndDate.value || undefined
                                      }

                                      setNewEndDate(d)
                                      setValue(formSchema.newEndDate.name, d)

                                      let datas = [...periodBudgetChange]

                                      datas[datas.length - 1].newEndDate =
                                        moment(d).format(DD_MM_YYYY_SLASH)

                                      datas[datas.length - 1].isChange = true

                                      setValue(
                                        `${formSchema?.periodBudget?.newEndDate?.name}_${datas[datas.length - 1]?.period}`,
                                        moment(d).toDate()
                                      )

                                      setPeriodBudgetChange(datas)
                                    }}
                                  />
                                )}
                              </>
                            )}

                            <Row>
                              <Col lg={12} md={12} sm={24} xs={24}>
                                {formSchema.newEndDate && (
                                  <>
                                    {formSchema.disabled ? (
                                      <p style={{ marginTop: 10 }}>
                                        <strong>{formSchema.newEndDate.label} : </strong>
                                        {moment(newEndDate, REQUEST_DATE_FORMAT).format(
                                          DD_MM_YYYY_SLASH
                                        )}
                                      </p>
                                    ) : (
                                      <InputDateForm
                                        isValue
                                        schema={formSchema.newEndDate}
                                        register={register}
                                        Controller={Controller}
                                        control={control}
                                        errors={errors}
                                        setValue={setValue}
                                        clearErrors={clearErrors}
                                        disabled={formSchema.disabled}
                                        value={newEndDate}
                                        startDate={
                                          overExtend
                                            ? formSchema.maxEndDate
                                              ? moment(formSchema.maxEndDate).add(1, 'days')
                                              : formSchema.oldEndDate
                                                ? moment(formSchema.oldEndDate).add(1, 'days')
                                                : undefined
                                            : undefined
                                        }
                                        endDate={
                                          overExtend
                                            ? undefined
                                            : formSchema.maxEndDate
                                              ? moment(formSchema.maxEndDate)
                                              : undefined
                                        }
                                        onChange={(val) => {
                                          console.log('val : ', val)

                                          setNewEndDate(moment(val).format(REQUEST_DATE_FORMAT))
                                          let datas = [...periodBudgetChange]

                                          console.log('setNewEndDate datas : ', datas)

                                          datas[datas.length - 1].newEndDate =
                                            moment(val).format(DD_MM_YYYY_SLASH)

                                          datas[datas.length - 1].isChange = true

                                          setValue(
                                            `${formSchema?.periodBudget?.newEndDate?.name}_${datas[datas.length - 1]?.period}`,
                                            val
                                          )

                                          setPeriodBudgetChange(datas)
                                        }}
                                      />
                                    )}
                                  </>
                                )}
                                <p style={{ marginTop: 10 }}>
                                  <b>
                                    จำนวนวันที่ขอขยาย{' '}
                                    {moment(newEndDate).diff(
                                      moment(formSchema.oldEndDate, REQUEST_DATE_FORMAT),
                                      'days'
                                    )}{' '}
                                    วัน
                                  </b>
                                </p>
                              </Col>
                            </Row>

                            {!formSchema.disabled &&
                              !changeType?.includes('2') &&
                              !changeType?.includes('3') && (
                                <Row>
                                  <Col lg={12} md={12} sm={24} xs={24}>
                                    {formSchema?.periodBudget?.reasonType && (
                                      <>
                                        {reasonErroMsg && (
                                          <Message
                                            showIcon
                                            type="error"
                                            description={reasonErroMsg}
                                            style={{ marginBottom: 10, marginTop: 10 }}
                                            onClose={() => setReasonErroMsg('')}
                                          />
                                        )}
                                        <InputMultiCascaderForm
                                          schema={formSchema.periodBudget.reasonType}
                                          register={register}
                                          Controller={Controller}
                                          control={control}
                                          errors={errors}
                                          setValue={setValue}
                                          clearErrors={clearErrors}
                                          menuHeight={350}
                                          menuWidth={300}
                                          value={reasonType}
                                          onChange={(val) => {
                                            onReasonTypeChange(val)
                                          }}
                                        />
                                      </>
                                    )}
                                  </Col>
                                  <Col lg={12} md={12} sm={24} xs={24}>
                                    {reasonType?.find((e) => e.endsWith('99')) &&
                                      formSchema?.periodBudget?.otherReason && (
                                        <InputForm
                                          schema={formSchema.periodBudget.otherReason}
                                          register={register}
                                          Controller={Controller}
                                          control={control}
                                          errors={errors}
                                          setValue={setValue}
                                          clearErrors={clearErrors}
                                          value={otherReason}
                                          onChange={(val) => {
                                            let datas = [...periodBudgetChange]

                                            datas[datas.length - 1].otherReason = val
                                            setOtherReason(val)
                                            setPeriodBudgetChange(datas)
                                          }}
                                        />
                                      )}
                                  </Col>
                                </Row>
                              )}
                          </div>
                        </Panel>
                      )}

                      {changeType?.includes('2') && (
                        <Panel
                          header={'กิจกรรมและงบประมาณ'}
                          bordered
                          collapsible
                          defaultExpanded={!schema.isApprover}
                          style={{ marginBottom: 10 }}
                        >
                          <div style={{ marginTop: -10 }}>
                            <ActivityBudget
                              hideOther
                              //hideActivity
                              schemaData={activitySchema}
                              disabled={formSchema.disabled}
                              projectVersionId={schema.projectVersionId}
                            />
                          </div>
                        </Panel>
                      )}

                      {(changeType?.includes('1') ||
                        changeType?.includes('2') ||
                        changeType?.includes('3')) &&
                        periodBudgetChange?.length > 0 && (
                          <>
                            <Panel
                              header={'งวดงานและงวดเงินที่ขอปรับแก้ไข '}
                              header={
                                <div
                                  style={{
                                    backgroundColor: '#f9dcc2',
                                    margin: '-20px -20px', // ชดเชย padding ของ Panel เดิม เพื่อให้สีเต็มขอบ
                                    padding: '20px 20px', // ใส่ padding กลับเข้าไปให้สวยงาม
                                    borderTopLeftRadius: '6px',
                                    borderTopRightRadius: '6px',
                                  }}
                                >
                                  งวดงานและงวดเงินที่ขอปรับแก้ไข
                                </div>
                              }
                              bordered
                              collapsible
                              defaultExpanded

                              // style={{ marginBottom: 10, backgroundColor: '#efd1b6' }}
                            >
                              {reasonErroMsg}
                              {(changeType?.includes('2') || changeType?.includes('3')) &&
                                reasonErroMsg && (
                                  <Message
                                    showIcon
                                    closable
                                    type="error"
                                    description={reasonErroMsg}
                                    style={{ marginBottom: 10, marginTop: 10 }}
                                    onClose={() => setReasonErroMsg('')}
                                  />
                                )}
                              <ContractChangeExtendPeriodBudget
                                schema={formSchema.periodBudget}
                                data={periodBudgetChange}
                                projectEndDate={newEndDate}
                                changeType={changeType}
                                isView={formSchema.disabled}
                                isEnableBudget={changeType?.includes('2')}
                                isEnablePeriod={changeType?.includes('3')}
                                isErrorRequire={!isEmpty(reasonErroMsg)}
                                register={register}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                setValue={setValue}
                                clearErrors={clearErrors}
                                setPeriodBudgetChange={setPeriodBudgetChange}
                              />
                            </Panel>
                          </>
                        )}

                      {formSchema.detail && (
                        <>
                          {formSchema.disabled ? (
                            <div style={{ marginTop: 20, marginBottom: 10 }}>
                              <p style={{ marginTop: 10 }}>
                                <strong>{formSchema.detail.label} :</strong>
                              </p>
                              <div style={{ marginLeft: 20 }}>
                                <HTMLWidget data={formSchema.detail.value} />
                              </div>
                            </div>
                          ) : (
                            <div style={{ marginTop: 10 }}>
                              <InputForm
                                schema={formSchema.detail}
                                componentClass={'textarea'}
                                rows={10}
                                //toolbar={[]}
                                register={register}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                setValue={setValue}
                                clearErrors={clearErrors}
                              />
                              {/* <CKEditorFrom
                                schema={formSchema.detail}
                                //toolbar={[]}
                                register={register}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                setValue={setValue}
                                clearErrors={clearErrors}
                              /> */}
                            </div>
                          )}
                        </>
                      )}

                      <ContractChangeExtendPeriodAttach
                        schema={formSchema.attachForm}
                        isEnableDel
                        isView={formSchema.disabled}
                        onDelete={onDeleteFile}
                        onDownload={(data) => {
                          handleDownload('download', data)
                        }}
                        onPreview={(data) => {
                          handleDownload('preview', data)
                        }}
                        control={control}
                        setAttachValues={setAttachValues}
                        errMsg={attachErrMsg}
                        periodBudget={periodBudgetChange}
                      />
                    </>
                  )}
                </>
              </>
            )}

            {formSchema?.validateMsgs?.length > 0 && (
              <CustomMessages datas={formSchema.validateMsgs} />
            )}

            <>
              {formSchema.action && (
                <>
                  <hr />
                  {formSchema.action.saveDarft && (
                    <SaveButton children={formSchema.action.saveDarft} onClick={onSaveDraf} />
                  )}

                  {formSchema.action.save && (
                    <SaveButton
                      icon="send"
                      children={formSchema.action.save}
                      onClick={handleSubmit(onSubmit)}
                    />
                  )}

                  {formSchema.action.sendBack && (
                    <EditButton
                      children={formSchema.action.sendBack}
                      onClick={() => {
                        setActionType(2)
                        setActionName(formSchema.action.sendBack)
                        setIsShowPopUp(true)
                      }}
                    />
                  )}

                  {formSchema.action.send && (
                    <ApproverList
                      approveType={5}
                      projectversionId={formSchema.projectVersionId}
                      style={{
                        marginRight: 10,
                        marginBottom: 10,
                      }}
                      buttontext={'ตรวจสอบสายอนุมัติและ' + formSchema.action.send}
                      //contractModifyType={changeType ? ['1', '3'] : ['1']}
                      isLoading={isLoading}
                      fetchButton={(disabled) => (
                        <SaveButton
                          icon="send"
                          children={formSchema.action.send}
                          onClick={() => {
                            setActionType(3)
                            setActionName(formSchema.action.send)
                            setIsShowPopUp(true)
                          }}
                          disabled={disabled}
                        />
                      )}
                    />
                  )}

                  {formSchema.action.checkButton && (
                    <ApproverList
                      approveType={5}
                      projectversionId={formSchema.projectVersionId}
                      style={{ marginLeft: 10 }}
                      buttontext={formSchema.action.CheckButton}
                      //contractModifyType={isEditActivity ? ['1', '3'] : ['1']}
                      isLoading={isLoading}
                      fetchButton={(disabled) =>
                        formSchema.action.fetchButton && (
                          <FetchNewApprover
                            approveType={5}
                            projectversionId={formSchema.projectVersionId}
                            style={{ marginRight: 10, marginBottom: 10 }}
                            buttontext={formSchema.action.FetchButton}
                            onSuccess={() => location.reload()}
                            disabled={disabled}
                          />
                        )
                      }
                    />
                  )}

                  {formSchema.action.cancelButton && (
                    <CancelApprovalList
                      approveType={5}
                      projectversionId={formSchema.projectVersionId}
                      style={{ marginRight: 10, marginBottom: 10 }}
                      buttontext={formSchema.action.cancelButton}
                      onSuccess={() => location.reload()}
                      //onSuccess={onRefash}
                    />
                  )}

                  {formSchema.action.notApprove && (
                    <CancelButton
                      icon="close-circle"
                      children={formSchema.action.notApprove}
                      onClick={() => {
                        setActionType(5)
                        setActionName(formSchema.action.notApprove)
                        setIsShowPopUp(true)
                      }}
                    />
                  )}

                  {formSchema.action.approve && (
                    <SaveButton
                      icon="check-circle"
                      children={formSchema.action.approve}
                      onClick={() => {
                        setActionType(4)
                        setActionName(formSchema.action.approve)
                        setIsShowPopUp(true)
                      }}
                    />
                  )}

                  {formSchema.action.deleteButton && (
                    <CancelButton
                      icon="trash"
                      children={formSchema.action.deleteButton}
                      onClick={() => {
                        setActionType(9)
                        setActionName(formSchema.action.deleteButton)
                        setIsShowPopUp(true)
                      }}
                    />
                  )}
                </>
              )}
            </>
          </>
        )}

        <ConfirmWidget
          title={`${actionType == 1 ? 'ยืนยัน' : actionName}`}
          show={isShowPopUp}
          size={[1, 9].includes(actionType) ? 'xs' : 'md'}
          disabled={disabledAction}
          detail={
            <div style={{ marginTop: -10 }}>
              {actionType == 1 ? (
                'ยืนยัน' + formSchema.action.save
              ) : actionType == 9 ? (
                'ยืนยัน' + formSchema.action.deleteButton
              ) : (
                <InputForm
                  schema={formSchema.note}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  componentClass={'textarea'}
                  rows={5}
                  onChange={(val) => {
                    setNote(val)
                    clearErrors()
                    setDisabledAction(false)
                  }}
                />
              )}
            </div>
          }
          onCancle={() => {
            setIsShowPopUp(false)
            setNote('')
          }}
          onConfirm={onConfirm}
        />
      </Panel>

      {formSchema.isApprover && (
        <Panel
          shaded
          header={'หนังสือขออนุมัติ'}
          collapsible
          defaultExpanded
          style={{ marginTop: 10 }}
        >
          {isPdfLoading ? (
            <div>
              <p style={{ marginTop: -10 }}>
                {requestFileErroMsg || 'กรุณารอสักครู่ ระบบกำลังโหลดเอกสาร ...'}
                <Loader />
              </p>
              {requestFileErroMsg && (
                <ViewButton
                  icon="reload"
                  children="โหลดใหม่"
                  onClick={() => {
                    let requestFile = formSchema?.attachForm?.values?.find((e) => e.typeId == '-')

                    if (requestFile) {
                      handleDownloadRequestFile(requestFile)
                    }
                  }}
                />
              )}

              <Paragraph rows={5} />
            </div>
          ) : (
            <RenderPDFWidget file={requestFile} />
          )}
        </Panel>
      )}
    </>
  )
}
